export const checkEnabledDietaryCertificate = (value) =>
  value?.toLowerCase() === 'yes';

const disabledCertifier = {
  kosherCertifier: 'kosherYN',
  organicCertifier: 'organicYN',
  halalCertifier: 'halalYN',
  nonGMOCertifier: 'nonGMOYN',
  isoCertifier: 'isoyn',
  brcCertifier: 'brcyn',
  ifsCertifier: 'ifsyn',
};

export const getCertificateParams = (formValues) => {
  return Object.keys(disabledCertifier).reduce((accumulator, currentKey) => {
    const checkValue = checkEnabledDietaryCertificate(
      formValues[disabledCertifier[currentKey]]
    );
    const value = formValues[currentKey];

    return { ...accumulator, [currentKey]: checkValue ? value : null };
  }, {});
};

export const parsePackagingData = (data) => {
  if (data) {
    return {
      ...data,
      recyclableTypes: data?.recyclableTypes || [],
      secondaryLanguage: data?.secondaryLanguage || [],
    };
  }

  return {};
};

export const mappingLabelingFields = {
  usage: {
    field: 'uses',
    displayName: 'Uses',
  },
  cookingInstructions: {
    field: 'directions',
    displayName: 'Directions',
  },
  storageInstructions: {
    field: 'storageInstructions',
    displayName: 'Storage Instructions/Other Information',
  },
};

export const mapLabelingFieldValueForHbcOtcType = ({
  isHbcOtcType,
  oldValue,
}) => {
  if (isHbcOtcType) {
    return mappingLabelingFields[oldValue]?.field;
  }
  return oldValue;
};

export const mapLabelingDisplayNameForHbcOtcType = ({
  isHbcOtcType,
  oldValue,
}) => {
  if (isHbcOtcType) {
    return mappingLabelingFields[oldValue]?.displayName ?? oldValue;
  }
  return oldValue;
};
